import { API_BASE_URL } from "../urls.api";

export const GET_COUNTRY_NAMES = `${API_BASE_URL}/countries/names`;
